<img
    [matTooltip]="position + '. ' + (name | translate)"
    matTooltipTouchGestures="off"
    [attr.src]="src"
    [attr.srcset]="srcSet"
    [style.width.px]="width"
    [attr.alt]="name | translate"
/>
